var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title-sidebar" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("dash.planner.sidebar.title"))),
            ]),
            _c("br"),
            _vm.post.status == "posted" &&
            _vm.post.page[0] &&
            _vm.post.page[0].isScheduledPost
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.$t(
                        "dash.detail.scheduled_date"
                      )} : ${_vm.formatDate(
                        _vm.post.posted_date,
                        "DD/MM/YY HH:mm"
                      )}`
                    )
                  ),
                ])
              : _vm.post.status == "posted"
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.$t("dash.detail.posted_date")} : ${_vm.formatDate(
                        _vm.post.posted_date,
                        "DD/MM/YY HH:mm"
                      )}`
                    )
                  ),
                ])
              : _vm.post.status == "scheduled"
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.$t(
                        "dash.detail.scheduled_date"
                      )} : ${_vm.formatDate(
                        _vm.post.scheduled_date,
                        "DD/MM/YY HH:mm"
                      )}`
                    )
                  ),
                ])
              : _vm.post.status == "preview" && _vm.sectionPlanner
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.$t("dash.detail.preview_date")} : ${_vm.formatDate(
                        _vm.post.preview_date,
                        "DD/MM/YY HH:mm"
                      )}`
                    )
                  ),
                ])
              : _vm.post.status == "slot"
              ? _c("span", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.$t("dash.detail.slot_date")} : ${_vm.formatDate(
                        _vm.post.date,
                        "DD/MM/YY HH:mm"
                      )}`
                    )
                  ),
                ])
              : _vm._e(),
          ]),
          ["scheduled", "posted", "failed", "draft"].includes(_vm.post.status)
            ? [
                _vm.post.page[0] &&
                _vm.post.page[0].wait_validation &&
                _vm.post.page[0].wait_validation != "null" &&
                _vm.getWaitValidation
                  ? _c(
                      "div",
                      { staticClass: "validated-post" },
                      [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.getWaitValidation.name)),
                        ]),
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.$t("dash.notification.validate_at")) +
                            "\n      "
                        ),
                        _c(
                          "Tooltip",
                          {
                            attrs: {
                              text: _vm.dateFormat(_vm.getWaitValidation.date),
                              position: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.dateFromNow(_vm.getWaitValidation.date)
                                )
                              ),
                            ]),
                            _vm._v("\n         \n      "),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                ["draft", "scheduled"].includes(_vm.post.status) &&
                !(_vm.invite || _vm.getUserRole == "Viewer") &&
                ((_vm.openPostSidebar &&
                  _vm.openPostSidebar.id == _vm.post.id &&
                  _vm.isAffectedUser) ||
                  (_vm.post.page &&
                    _vm.post.page[0] &&
                    _vm.post.page[0].affectedTo &&
                    ((_vm.post.page[0].affectedTo.user &&
                      _vm.post.page[0].affectedTo.user.id == _vm.getUserId) ||
                      (_vm.post.page[0].affectedTo.users &&
                        _vm.post.page[0].affectedTo.users.find(
                          (u) => u && u.id == _vm.getUserId
                        )))))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx validated-post-btn",
                        attrs: { type: "filled" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.post.page &&
                            _vm.post.page[0] &&
                            _vm.post.page[0].wait_validation &&
                            _vm.post.page[0].wait_validation != "null"
                              ? _vm.removeValidation()
                              : _vm.post.status == "draft"
                              ? _vm.draftToSchedule()
                              : _vm.validatePostInvite()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(
                              _vm.$t(
                                _vm.post.page &&
                                  _vm.post.page[0] &&
                                  _vm.post.page[0].wait_validation &&
                                  _vm.post.page[0].wait_validation != "null"
                                  ? "dash.button.validate.scheduled_post.remove"
                                  : "dash.button.validate.scheduled_post"
                              )
                            ) +
                            "\n    "
                        ),
                      ]
                    )
                  : ["scheduled", "draft"].includes(_vm.post.status) &&
                    !(
                      _vm.invite ||
                      ["Viewer", "Writter"].includes(_vm.getUserRole)
                    )
                  ? [
                      _c("div", { staticClass: "affected_to" }, [
                        _c("div", { staticClass: "affected_to-title" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("dash.post.affected_to.title")) +
                              "\n          "
                          ),
                          !_vm.openPostSidebar ||
                          _vm.openPostSidebar.id != _vm.post.id
                            ? _c(
                                "div",
                                {
                                  staticClass: "add-user",
                                  on: {
                                    click: function ($event) {
                                      _vm.popupSelectUser = true
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-user-plus",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm.post.page &&
                          _vm.post.page[0] &&
                          _vm.post.page[0].affectedTo &&
                          _vm.post.page[0].affectedTo.users &&
                          _vm.post.page[0].affectedTo.users.length > 1
                            ? _c("div", { staticClass: "list" }, [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.post.page[0].affectedTo.users,
                                    function (user, indexU) {
                                      return _c("li", { key: indexU }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              `${user.lastname} ${user.firstname}`
                                            )
                                          ),
                                        ]),
                                        _vm._v(
                                          " (" +
                                            _vm._s(user.email) +
                                            ")\n              "
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm.post.page &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].affectedTo &&
                              _vm.post.page[0].affectedTo.user
                            ? _c("div", { staticClass: "list" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.post.page[0].affectedTo.user.lastname} ${_vm.post.page[0].affectedTo.user.firstname}`
                                    )
                                  ),
                                ]),
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.post.page[0].affectedTo.user.email
                                    ) +
                                    ")\n          "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "vs-popup",
                        {
                          staticClass:
                            "overlay groups shared-planner affected_to post-sidebar",
                          attrs: {
                            title: _vm.$t("dash.inbox.event.affected_to.title"),
                            active: _vm.popupSelectUser,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.popupSelectUser = $event
                            },
                          },
                        },
                        [
                          _vm.popupSelectUser
                            ? _c("component-users-selector", {
                                attrs: {
                                  manager: true,
                                  usersAdded:
                                    _vm.post.page &&
                                    _vm.post.page[0] &&
                                    _vm.post.page[0].affectedTo &&
                                    (_vm.post.page[0].affectedTo.users ||
                                      _vm.post.page[0].affectedTo.user)
                                      ? _vm.post.page[0].affectedTo.users &&
                                        _vm.post.page[0].affectedTo.users
                                          .length > 1
                                        ? _vm.post.page[0].affectedTo.users
                                        : [_vm.post.page[0].affectedTo.user]
                                      : [],
                                  type: "affected_to",
                                  editOptionValidation:
                                    _vm.post.page &&
                                    _vm.post.page[0] &&
                                    _vm.post.page[0].affectedTo &&
                                    (_vm.post.page[0].affectedTo.users ||
                                      _vm.post.page[0].affectedTo.user)
                                      ? _vm.post.page[0].affectedTo
                                          .optionValidation
                                      : null,
                                },
                                on: { submit: _vm.addAffectedToPost },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                ["scheduled", "draft"].includes(_vm.post.status) &&
                (_vm.invite || _vm.getUserRole == "Viewer") &&
                _vm.checkWaitValidation
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx validated-post-btn",
                        attrs: { type: "filled" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.validatePostInvite()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(
                              _vm.$t("dash.button.validate.scheduled_post")
                            ) +
                            "\n    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.post.page &&
          _vm.post.page[0] &&
          _vm.post.page[0].log &&
          _vm.post.page[0].log.length &&
          !(_vm.invite || _vm.getUserRole == "Viewer")
            ? _c(
                "div",
                { staticClass: "history" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "history-title",
                      on: {
                        click: function ($event) {
                          _vm.showLogs = !_vm.showLogs
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("dash.detail.history")) + " "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              `dash.detail.history.${
                                _vm.showLogs ? "minimize" : "maximize"
                              }`
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm.showLogs
                    ? _c(
                        "vs-collapse",
                        { staticClass: "log" },
                        _vm._l(_vm.post.page[0].log, function (log, index) {
                          return _c(
                            "vs-collapse-item",
                            {
                              key: `log-${index}`,
                              attrs: {
                                disabled:
                                  _vm.isDifferencesEmpty(log.differences) &&
                                  !log.affected_to &&
                                  !log.wait_validation &&
                                  !log.wait_validation_removed &&
                                  !log.resetWaitValidation,
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: `${
                                          _vm.getLogUser(log.user).name
                                        }`,
                                        position: "top",
                                      },
                                    },
                                    [
                                      _vm.getLogUser(log.user).avatar &&
                                      _vm.getLogUser(log.user).avatar != "null"
                                        ? _c("img", {
                                            staticClass: "image-user",
                                            attrs: {
                                              alt: _vm.getLogUser(log.user)
                                                .name,
                                              src: _vm.getLogUser(log.user)
                                                .avatar,
                                            },
                                          })
                                        : _c("img", {
                                            staticClass: "image-user",
                                            attrs: { src: "img/avatar.jpg" },
                                          }),
                                    ]
                                  ),
                                  _c("div", { staticClass: "type-date" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `dash.detail.history.log-${
                                            log.created_at
                                              ? "created"
                                              : log.removed_at
                                              ? "removed"
                                              : "updated"
                                          }${
                                            log.isDraft
                                              ? "-draft"
                                              : log.isScheduled
                                              ? "-scheduled"
                                              : ""
                                          }`
                                        )
                                      ) +
                                        " " +
                                        _vm._s(_vm.getDateLog(log))
                                    ),
                                  ]),
                                  _vm.getLogUser(log.user).email
                                    ? _c("div", { staticClass: "by" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(`dash.detail.history.log-by`)
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.getLogUser(log.user).email
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "content-log" }, [
                                log.affected_to
                                  ? _c("div", { staticClass: "differences" }, [
                                      _c(
                                        "div",
                                        { staticClass: "difference-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.post.affected_to.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      log.affected_to.users
                                        ? _c(
                                            "ul",
                                            _vm._l(
                                              log.affected_to.users,
                                              function (u, indexU) {
                                                return _c(
                                                  "li",
                                                  { key: `log-${indexU}` },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "name" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(u.firstname) +
                                                            " " +
                                                            _vm._s(u.lastname) +
                                                            " "
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(u.email) +
                                                              ")"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : log.affected_to.user
                                        ? _c("ul", [
                                            _c("li", [
                                              _c(
                                                "div",
                                                { staticClass: "name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.affected_to.user
                                                        .firstname
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        log.affected_to.user
                                                          .lastname
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          log.affected_to.user
                                                            .email
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : log.wait_validation
                                  ? _c("div", { staticClass: "differences" }, [
                                      _c(
                                        "div",
                                        { staticClass: "difference-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.post.wait_validation.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _c("div", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(log.wait_validation.name) +
                                                " "
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    log.wait_validation.email
                                                  ) +
                                                  ")"
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                      ]),
                                    ])
                                  : log.wait_validation_removed ||
                                    log.resetWaitValidation
                                  ? _c("div", { staticClass: "differences" }, [
                                      _c(
                                        "div",
                                        { staticClass: "difference-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.post.wait_validation_removed.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : log.differences &&
                                    log.differences.filter((d) => d).length
                                  ? _c("div", { staticClass: "differences" }, [
                                      _c(
                                        "div",
                                        { staticClass: "difference-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.detail.history.change"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "ul",
                                        _vm._l(
                                          log.differences.filter((d) => d),
                                          function (difference, indexDiff) {
                                            return _c(
                                              "li",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.showLogDifference(
                                                        difference
                                                      ),
                                                    expression:
                                                      "showLogDifference(difference)",
                                                  },
                                                ],
                                                key: indexDiff,
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `dash.detail.history.difference.${difference.name}`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.detail.history.difference.oldValue"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    difference.name == "bot"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (botId) {
                                                              return _c(
                                                                "li",
                                                                { key: botId },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.getPageNameByBotId(
                                                                          botId
                                                                        )
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "validMentions"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              mentions,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                _vm._l(
                                                                  mentions,
                                                                  function (
                                                                    mention
                                                                  ) {
                                                                    return _c(
                                                                      "li",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                mention.network ==
                                                                                _vm
                                                                                  .post
                                                                                  ._bots[0]
                                                                                  .page
                                                                                  .network,
                                                                              expression:
                                                                                "mention.network == post._bots[0].page.network",
                                                                            },
                                                                          ],
                                                                        key: mention.network,
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              `MENTIONS-${
                                                                                idM +
                                                                                1
                                                                              } : ${
                                                                                mention.value ||
                                                                                mention.word
                                                                              }`
                                                                            ) +
                                                                            "\n                      "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "editPostValue"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              editPostValue,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  editPostValue.page ==
                                                                    _vm.post
                                                                      ._bots[0]
                                                                      .page
                                                                      .id &&
                                                                  editPostValue.title
                                                                    ? _c("li", [
                                                                        editPostValue.title
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "dash.detail.history.difference.editPostValue.title"
                                                                                    )
                                                                                  ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      editPostValue.title
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ])
                                                                    : _vm._e(),
                                                                  editPostValue.page ==
                                                                    _vm.post
                                                                      ._bots[0]
                                                                      .page
                                                                      .id &&
                                                                  editPostValue.scheduling
                                                                    ? _c("li", [
                                                                        editPostValue.scheduling
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scheduling",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "dash.detail.history.difference.editPostValue.scheduling"
                                                                                    )
                                                                                  ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      _vm.dateFormat(
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .date,
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .time
                                                                                          .HH,
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .time
                                                                                          .mm
                                                                                      )
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ])
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "scheduling"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.dateFormat(
                                                                  difference
                                                                    .oldValue
                                                                    .lastScheduled ||
                                                                    difference
                                                                      .oldValue
                                                                      .date
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : [
                                                          "filename",
                                                          "videoname",
                                                        ].includes(
                                                          difference.name
                                                        ) &&
                                                        ![
                                                          _vm.$t(
                                                            "dash.message.no.file"
                                                          ),
                                                          _vm.$t(
                                                            "dash.message.no.video"
                                                          ),
                                                        ].includes(
                                                          difference.oldValue
                                                        )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: `https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${difference.oldValue}`,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    difference.oldValue
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : [
                                                          "tiktokOptions",
                                                          "youtubeOptions",
                                                          "twitterOptions",
                                                          "facebookOptions",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            _vm.objectToArray(
                                                              JSON.parse(
                                                                difference.oldValue
                                                              )
                                                            ),
                                                            function (
                                                              option,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !_vm.objectToArray(
                                                                          JSON.parse(
                                                                            difference.newValue
                                                                          )
                                                                        )[
                                                                          idM
                                                                        ] ||
                                                                        option.name !=
                                                                          _vm.objectToArray(
                                                                            JSON.parse(
                                                                              difference.newValue
                                                                            )
                                                                          )[idM]
                                                                            .name ||
                                                                        option.value !=
                                                                          _vm.objectToArray(
                                                                            JSON.parse(
                                                                              difference.newValue
                                                                            )
                                                                          )[idM]
                                                                            .value,
                                                                      expression:
                                                                        "!objectToArray(JSON.parse(difference.newValue))[idM] || option.name != objectToArray(JSON.parse(difference.newValue))[idM].name || option.value != objectToArray(JSON.parse(difference.newValue))[idM].value",
                                                                    },
                                                                  ],
                                                                  key: idM,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                        )
                                                                      ) +
                                                                      " : " +
                                                                      _vm._s(
                                                                        option.value
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "instagramLinkPosition",
                                                          "pollStory",
                                                          "sliderStory",
                                                        ].includes(
                                                          difference.name
                                                        ) && difference.oldValue
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            _vm.objectToArray(
                                                              difference.oldValue
                                                            ),
                                                            function (
                                                              option,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !difference.newValue ||
                                                                        !_vm.objectToArray(
                                                                          difference.newValue
                                                                        )[
                                                                          idM
                                                                        ] ||
                                                                        option.name !=
                                                                          _vm.objectToArray(
                                                                            difference.newValue
                                                                          )[idM]
                                                                            .name ||
                                                                        option.value !=
                                                                          _vm.objectToArray(
                                                                            difference.newValue
                                                                          )[idM]
                                                                            .value,
                                                                      expression:
                                                                        "!difference.newValue || !objectToArray(difference.newValue)[idM] || option.name != objectToArray(difference.newValue)[idM].name || option.value != objectToArray(difference.newValue)[idM].value",
                                                                    },
                                                                  ],
                                                                  key: idM,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                        )
                                                                      ) +
                                                                      " : " +
                                                                      _vm._s(
                                                                        option.value
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "instagramTexts",
                                                          "storyMentions",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              text,
                                                              idT
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        JSON.stringify(
                                                                          text
                                                                        ) !=
                                                                        JSON.stringify(
                                                                          difference
                                                                            .newValue[
                                                                            idT
                                                                          ]
                                                                        ),
                                                                      expression:
                                                                        "JSON.stringify(text) != JSON.stringify(difference.newValue[idT])",
                                                                    },
                                                                  ],
                                                                  key: idT,
                                                                  staticClass:
                                                                    "decimal",
                                                                },
                                                                [
                                                                  _c(
                                                                    "ul",
                                                                    _vm._l(
                                                                      _vm.objectToArray(
                                                                        text
                                                                      ),
                                                                      function (
                                                                        option,
                                                                        idM
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    !_vm.objectToArray(
                                                                                      difference
                                                                                        .newValue[
                                                                                        idT
                                                                                      ]
                                                                                    )[
                                                                                      idM
                                                                                    ] ||
                                                                                    option.name !=
                                                                                      _vm.objectToArray(
                                                                                        difference
                                                                                          .newValue[
                                                                                          idT
                                                                                        ]
                                                                                      )[
                                                                                        idM
                                                                                      ]
                                                                                        .name ||
                                                                                    option.value !=
                                                                                      _vm.objectToArray(
                                                                                        difference
                                                                                          .newValue[
                                                                                          idT
                                                                                        ]
                                                                                      )[
                                                                                        idM
                                                                                      ]
                                                                                        .value,
                                                                                  expression:
                                                                                    "!objectToArray(difference.newValue[idT])[idM] || option.name != objectToArray(difference.newValue[idT])[idM].name || option.value != objectToArray(difference.newValue[idT])[idM].value",
                                                                                },
                                                                              ],
                                                                            key: idM,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                          " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                                  )
                                                                                ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  option.value
                                                                                ) +
                                                                                "\n                        "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "selectedGifs",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              gif,
                                                              idT
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                { key: idT },
                                                                [
                                                                  _c("ul", [
                                                                    _c("li", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            `dash.detail.history.difference.selectedGifs.title`
                                                                          )
                                                                        ) +
                                                                          " : " +
                                                                          _vm._s(
                                                                            gif.title
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "gif",
                                                                          attrs:
                                                                            {
                                                                              src: gif
                                                                                .images
                                                                                .downsized
                                                                                .url,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]),
                                                                    !difference
                                                                      .newValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .newValue[
                                                                      idT
                                                                    ].w != gif.w
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.w`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.w
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .newValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .newValue[
                                                                      idT
                                                                    ].h != gif.h
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.h`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.h
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .newValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .newValue[
                                                                      idT
                                                                    ].x != gif.x
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.x`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.x
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .newValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .newValue[
                                                                      idT
                                                                    ].y != gif.y
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.y`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.y
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "multipleImages"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              image,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  _c("li", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: image.url,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            image.url
                                                                              .split(
                                                                                "/"
                                                                              )
                                                                              .pop()
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    image[
                                                                      _vm.post
                                                                        .page[0]
                                                                        .network
                                                                    ] >= 0
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "order",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "dash.detail.history.difference.multipleImages.order"
                                                                                )
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  image[
                                                                                    _vm
                                                                                      .post
                                                                                      .page[0]
                                                                                      .network
                                                                                  ] +
                                                                                    1
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.post
                                                                      .page[0]
                                                                      .network ==
                                                                    "instagram"
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ratio",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "dash.detail.history.difference.multipleImages.ratio"
                                                                                )
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    `dash.detail.history.difference.multipleImages.ratio.${image.ratio}`
                                                                                  )
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "multipleMedias"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          _vm._l(
                                                            difference.oldValue,
                                                            function (
                                                              media,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  _c("li", [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          idM +
                                                                            1
                                                                        ) +
                                                                        " - "
                                                                    ),
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: media.url,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            media.url
                                                                              .split(
                                                                                "/"
                                                                              )
                                                                              .pop()
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "instagramBackgroundColor"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          [
                                                            difference.oldValue
                                                              ? _c("span", {
                                                                  staticClass:
                                                                    "color-sample",
                                                                  style: `background:rgba(${difference.oldValue[0]},${difference.oldValue[1]},${difference.oldValue[2]},${difference.oldValue[3]});`,
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(
                                                              _vm._s(
                                                                difference.oldValue
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "old-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  JSON.stringify(
                                                                    difference.oldValue
                                                                  )
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.detail.history.difference.newValue"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    difference.name == "bot"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (botId) {
                                                              return _c(
                                                                "li",
                                                                { key: botId },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.getPageNameByBotId(
                                                                          botId
                                                                        )
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "validMentions"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              mentions,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                _vm._l(
                                                                  mentions,
                                                                  function (
                                                                    mention
                                                                  ) {
                                                                    return _c(
                                                                      "li",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                mention.network ==
                                                                                _vm
                                                                                  .post
                                                                                  ._bots[0]
                                                                                  .page
                                                                                  .network,
                                                                              expression:
                                                                                "mention.network == post._bots[0].page.network",
                                                                            },
                                                                          ],
                                                                        key: mention.network,
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                        " +
                                                                            _vm._s(
                                                                              `MENTIONS-${
                                                                                idM +
                                                                                1
                                                                              } : ${
                                                                                mention.value ||
                                                                                mention.word
                                                                              }`
                                                                            ) +
                                                                            "\n                      "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "editPostValue"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              editPostValue,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  editPostValue.page ==
                                                                    _vm.post
                                                                      ._bots[0]
                                                                      .page
                                                                      .id &&
                                                                  editPostValue.title
                                                                    ? _c("li", [
                                                                        editPostValue.title
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "dash.detail.history.difference.editPostValue.title"
                                                                                    )
                                                                                  ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      editPostValue.title
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ])
                                                                    : _vm._e(),
                                                                  editPostValue.page ==
                                                                    _vm.post
                                                                      ._bots[0]
                                                                      .page
                                                                      .id &&
                                                                  editPostValue.scheduling
                                                                    ? _c("li", [
                                                                        editPostValue.scheduling
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scheduling",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "dash.detail.history.difference.editPostValue.scheduling"
                                                                                    )
                                                                                  ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      _vm.dateFormat(
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .date,
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .time
                                                                                          .HH,
                                                                                        editPostValue
                                                                                          .scheduling
                                                                                          .time
                                                                                          .mm
                                                                                      )
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ])
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "scheduling"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.dateFormat(
                                                                  difference
                                                                    .newValue
                                                                    .lastScheduled ||
                                                                    difference
                                                                      .newValue
                                                                      .date
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : [
                                                          "filename",
                                                          "videoname",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: `https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${difference.newValue}`,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    difference.newValue
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : ["videos"].includes(
                                                          difference.name
                                                        ) &&
                                                        _vm.getVideoName(
                                                          difference.newValue
                                                        )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: `https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${_vm.getVideoName(
                                                                    difference.newValue
                                                                  )}`,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getVideoName(
                                                                      difference.newValue
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : [
                                                          "tiktokOptions",
                                                          "youtubeOptions",
                                                          "twitterOptions",
                                                          "facebookOptions",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            _vm.objectToArray(
                                                              JSON.parse(
                                                                difference.newValue
                                                              )
                                                            ),
                                                            function (
                                                              option,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !_vm.objectToArray(
                                                                          JSON.parse(
                                                                            difference.oldValue
                                                                          )
                                                                        )[
                                                                          idM
                                                                        ] ||
                                                                        option.name !=
                                                                          _vm.objectToArray(
                                                                            JSON.parse(
                                                                              difference.oldValue
                                                                            )
                                                                          )[idM]
                                                                            .name ||
                                                                        option.value !=
                                                                          _vm.objectToArray(
                                                                            JSON.parse(
                                                                              difference.oldValue
                                                                            )
                                                                          )[idM]
                                                                            .value,
                                                                      expression:
                                                                        "!objectToArray(JSON.parse(difference.oldValue))[idM] || option.name != objectToArray(JSON.parse(difference.oldValue))[idM].name || option.value != objectToArray(JSON.parse(difference.oldValue))[idM].value",
                                                                    },
                                                                  ],
                                                                  key: idM,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                        )
                                                                      ) +
                                                                      " : " +
                                                                      _vm._s(
                                                                        option.value
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "instagramLinkPosition",
                                                          "pollStory",
                                                          "sliderStory",
                                                        ].includes(
                                                          difference.name
                                                        ) && difference.newValue
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            _vm.objectToArray(
                                                              difference.newValue
                                                            ),
                                                            function (
                                                              option,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !difference.oldValue ||
                                                                        !_vm.objectToArray(
                                                                          difference.oldValue
                                                                        )[
                                                                          idM
                                                                        ] ||
                                                                        option.name !=
                                                                          _vm.objectToArray(
                                                                            difference.oldValue
                                                                          )[idM]
                                                                            .name ||
                                                                        option.value !=
                                                                          _vm.objectToArray(
                                                                            difference.oldValue
                                                                          )[idM]
                                                                            .value,
                                                                      expression:
                                                                        "!difference.oldValue || !objectToArray(difference.oldValue)[idM] || option.name != objectToArray(difference.oldValue)[idM].name || option.value != objectToArray(difference.oldValue)[idM].value",
                                                                    },
                                                                  ],
                                                                  key: idM,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                        )
                                                                      ) +
                                                                      " : " +
                                                                      _vm._s(
                                                                        option.value
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "instagramTexts",
                                                          "storyMentions",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              text,
                                                              idT
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        JSON.stringify(
                                                                          text
                                                                        ) !=
                                                                        JSON.stringify(
                                                                          difference
                                                                            .oldValue[
                                                                            idT
                                                                          ]
                                                                        ),
                                                                      expression:
                                                                        "JSON.stringify(text) != JSON.stringify(difference.oldValue[idT])",
                                                                    },
                                                                  ],
                                                                  key: idT,
                                                                  staticClass:
                                                                    "decimal",
                                                                },
                                                                [
                                                                  _c(
                                                                    "ul",
                                                                    _vm._l(
                                                                      _vm.objectToArray(
                                                                        text
                                                                      ),
                                                                      function (
                                                                        option,
                                                                        idM
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    !difference
                                                                                      .oldValue[
                                                                                      idT
                                                                                    ] ||
                                                                                    !_vm.objectToArray(
                                                                                      difference
                                                                                        .oldValue[
                                                                                        idT
                                                                                      ]
                                                                                    )[
                                                                                      idM
                                                                                    ] ||
                                                                                    option.name !=
                                                                                      _vm.objectToArray(
                                                                                        difference
                                                                                          .oldValue[
                                                                                          idT
                                                                                        ]
                                                                                      )[
                                                                                        idM
                                                                                      ]
                                                                                        .name ||
                                                                                    option.value !=
                                                                                      _vm.objectToArray(
                                                                                        difference
                                                                                          .oldValue[
                                                                                          idT
                                                                                        ]
                                                                                      )[
                                                                                        idM
                                                                                      ]
                                                                                        .value,
                                                                                  expression:
                                                                                    "!difference.oldValue[idT] || !objectToArray(difference.oldValue[idT])[idM] || option.name != objectToArray(difference.oldValue[idT])[idM].name || option.value != objectToArray(difference.oldValue[idT])[idM].value",
                                                                                },
                                                                              ],
                                                                            key: idM,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                          " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    `dash.detail.history.difference.${difference.name}.${option.name}`
                                                                                  )
                                                                                ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  option.value
                                                                                ) +
                                                                                "\n                        "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : [
                                                          "selectedGifs",
                                                        ].includes(
                                                          difference.name
                                                        )
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              gif,
                                                              idT
                                                            ) {
                                                              return _c(
                                                                "li",
                                                                { key: idT },
                                                                [
                                                                  _c("ul", [
                                                                    _c("li", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            `dash.detail.history.difference.selectedGifs.title`
                                                                          )
                                                                        ) +
                                                                          " : " +
                                                                          _vm._s(
                                                                            gif.title
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "gif",
                                                                          attrs:
                                                                            {
                                                                              src: gif
                                                                                .images
                                                                                .downsized
                                                                                .url,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]),
                                                                    !difference
                                                                      .oldValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .oldValue[
                                                                      idT
                                                                    ].w != gif.w
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.w`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.w
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .oldValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .oldValue[
                                                                      idT
                                                                    ].h != gif.h
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.h`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.h
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .oldValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .oldValue[
                                                                      idT
                                                                    ].x != gif.x
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.x`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.x
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !difference
                                                                      .oldValue[
                                                                      idT
                                                                    ] ||
                                                                    difference
                                                                      .oldValue[
                                                                      idT
                                                                    ].y != gif.y
                                                                      ? _c(
                                                                          "li",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  `dash.detail.history.difference.selectedGifs.y`
                                                                                )
                                                                              ) +
                                                                                " : " +
                                                                                _vm._s(
                                                                                  gif.y
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "multipleImages"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              image,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  _c("li", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: image.url,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            image.url
                                                                              .split(
                                                                                "/"
                                                                              )
                                                                              .pop()
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    image[
                                                                      _vm.post
                                                                        .page[0]
                                                                        .network
                                                                    ] >= 0
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "order",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "dash.detail.history.difference.multipleImages.order"
                                                                                )
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  image[
                                                                                    _vm
                                                                                      .post
                                                                                      .page[0]
                                                                                      .network
                                                                                  ] +
                                                                                    1
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.post
                                                                      .page[0]
                                                                      .network ==
                                                                    "instagram"
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ratio",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "dash.detail.history.difference.multipleImages.ratio"
                                                                                )
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    `dash.detail.history.difference.multipleImages.ratio.${image.ratio}`
                                                                                  )
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "multipleMedias"
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          _vm._l(
                                                            difference.newValue,
                                                            function (
                                                              media,
                                                              idM
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                { key: idM },
                                                                [
                                                                  _c("li", [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          idM +
                                                                            1
                                                                        ) +
                                                                        " - "
                                                                    ),
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: media.url,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            media.url
                                                                              .split(
                                                                                "/"
                                                                              )
                                                                              .pop()
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : difference.name ==
                                                        "instagramBackgroundColor"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          [
                                                            difference.newValue
                                                              ? _c("span", {
                                                                  staticClass:
                                                                    "color-sample",
                                                                  style: `background:rgba(${difference.newValue[0]},${difference.newValue[1]},${difference.newValue[2]},${difference.newValue[3]});`,
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(
                                                              _vm._s(
                                                                difference.newValue
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "new-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  JSON.stringify(
                                                                    difference.newValue
                                                                  )
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.post && _vm.post.status != "slot"
            ? _c("div", { staticClass: "post" }, [
                _vm.post.status == "draft" &&
                !(_vm.invite || _vm.getUserRole == "Viewer") &&
                _vm.editDraftNotAllowed
                  ? _c("div", { staticClass: "info" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              `dash.post-sidebar.info.edit-draft.not-allowed${
                                _vm.getUserRole == "Admin" ? ".admin" : ""
                              }`
                            )
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm.post.status == "failed"
                  ? _c("div", { staticClass: "failed" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("dash.post.failed.tooltip")) +
                          "\n      "
                      ),
                      _vm.post.page.length &&
                      _vm.post.page[0].network == "twitter" &&
                      _vm.post.page[0].post_number == "duplicate"
                        ? _c("span", [_vm._v("Duplicate")])
                        : _vm.post.page.length &&
                          _vm.post.page[0].status == 4 &&
                          _vm.post.page[0].post_number == "[object Object]"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("dash.bots.error.title"))),
                          ])
                        : _vm.post.page.length && _vm.post.page[0].status == 4
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.post.page[0].post_number)),
                          ])
                        : _vm._e(),
                    ])
                  : _c(
                      "div",
                      { staticClass: "post-selected" },
                      [
                        _vm.sectionPlanner
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("dash.post.selected"))),
                            ])
                          : _vm._e(),
                        ["scheduled", "draft"].includes(_vm.post.status) &&
                        !(
                          _vm.post._bots[0].page.isGroup &&
                          _vm.post._bots[0].page.network == "facebook"
                        ) &&
                        !(_vm.invite || _vm.getUserRole == "Viewer") &&
                        (["Admin", "Editor"].includes(_vm.getUserRole) ||
                          (_vm.getUserRole == "Writter" &&
                            _vm.post.status == "draft"))
                          ? _c(
                              "vs-button",
                              {
                                staticClass: "btnx",
                                attrs: {
                                  type: "filled",
                                  disabled:
                                    _vm.hasAccessAllPage ||
                                    _vm.editDraftNotAllowed ||
                                    _vm.postingInProgress,
                                  "data-qa": "post-sidebar-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editPost(
                                      _vm.post._bots[0].page.id,
                                      _vm.post._id,
                                      _vm.post.status,
                                      null,
                                      _vm.post._bots
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("dash.button.edit.post")) +
                                    "\n      "
                                ),
                              ]
                            )
                          : ["posted"].includes(_vm.post.status) &&
                            _vm.canUpdatePostedPost &&
                            !(_vm.invite || _vm.getUserRole == "Viewer") &&
                            ["Admin", "Editor"].includes(_vm.getUserRole)
                          ? _c(
                              "vs-button",
                              {
                                staticClass: "btnx",
                                attrs: {
                                  type: "filled",
                                  disabled:
                                    _vm.hasAccessAllPage ||
                                    _vm.editDraftNotAllowed ||
                                    _vm.postingInProgress,
                                  "data-qa": "post-sidebar-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editPost(
                                      _vm.post._bots[0].page.id,
                                      _vm.post._id,
                                      _vm.post.status,
                                      null,
                                      _vm.post._bots
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("dash.button.edit.post")) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.post.status == "preview" &&
                        !(_vm.invite || _vm.getUserRole == "Viewer") &&
                        !(
                          _vm.post._bots[0].mode === "story" &&
                          _vm.post._bots[0].page.story_config &&
                          _vm.post._bots[0].page.story_config.created
                        )
                          ? _c(
                              "vs-button",
                              {
                                staticClass: "btnx",
                                attrs: {
                                  type: "filled",
                                  "data-qa": "post-sidebar-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editPost(
                                      _vm.post._bots[0].page.id,
                                      _vm.post._id,
                                      _vm.post.status,
                                      _vm.post.preview_date,
                                      _vm.post._bots
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("dash.button.edit.post")) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.post.status == "posted" &&
                        [
                          "facebook",
                          "twitter",
                          "linkedin",
                          "pinterest",
                          "google",
                          "youtube",
                          "threads",
                          "bluesky",
                        ].includes(_vm.post._bots[0].page.network) &&
                        !(
                          _vm.post._bots[0].page.network === "linkedin" &&
                          !/^[0-9]+$/.test(_vm.post._bots[0].page.network_id)
                        ) &&
                        !(
                          _vm.post.page &&
                          _vm.post.page[0] &&
                          _vm.post.page[0].story
                        )
                          ? _c(
                              "vs-button",
                              {
                                staticClass: "btnx",
                                attrs: { type: "filled" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.showPost(
                                      _vm.post._bots[0].page,
                                      _vm.post
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.$t("dash.posts.view")) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                _vm.post && _vm.post.status != "slot"
                  ? _c(
                      "div",
                      {
                        ref: `preview-post-${_vm.post._bots[0].id}`,
                        staticClass: "slot",
                        attrs: { id: `preview-post-${_vm.post._bots[0].id}` },
                      },
                      [
                        _c("preview-post", {
                          key: _vm.post._id,
                          attrs: {
                            page: _vm.post._bots[0].page,
                            post: _vm.post,
                            retweet:
                              _vm.post._bots[0].page.network == "twitter" &&
                              ["posted", "scheduled"].includes(
                                _vm.post.status
                              ) &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].is_retweet
                                ? _vm.post._bots[0].page
                                : null,
                            activeMentionsAutoReplace:
                              ["scheduled", "direct"].includes(
                                _vm.post.status
                              ) ||
                              (["posted", "failed", "removed"].includes(
                                _vm.post.status
                              ) &&
                                _vm.post.page[0] &&
                                (_vm.post.page[0].is_manual_post ||
                                  _vm.post.page[0].isManualPost))
                                ? false
                                : true,
                            activeHashtagsAutoAdd:
                              ["scheduled", "direct"].includes(
                                _vm.post.status
                              ) ||
                              (["posted", "failed", "removed"].includes(
                                _vm.post.status
                              ) &&
                                _vm.post.page[0] &&
                                (_vm.post.page[0].is_manual_post ||
                                  _vm.post.page[0].isManualPost))
                                ? false
                                : true,
                            activePrefixSuffix:
                              ["scheduled", "direct"].includes(
                                _vm.post.status
                              ) ||
                              (["posted", "failed", "removed"].includes(
                                _vm.post.status
                              ) &&
                                _vm.post.page[0] &&
                                (_vm.post.page[0].is_manual_post ||
                                  _vm.post.page[0].isManualPost)) ||
                              (_vm.post.status == "draft" &&
                                _vm.post.draft &&
                                _vm.post.draft.data &&
                                !_vm.post.draft.data.activePrefixSuffix)
                                ? false
                                : true,
                            videoReel:
                              _vm.post.page && _vm.post.page[0]
                                ? _vm.post.page[0].videoReel
                                : false,
                            typePost:
                              _vm.post.status == "draft" && _vm.post.typePost
                                ? _vm.post.typePost
                                : undefined,
                            validMentions:
                              _vm.post.status == "draft" &&
                              _vm.post.data.validMentions
                                ? _vm.post.data.validMentions
                                : undefined,
                            validHashtags:
                              _vm.post.status == "draft" &&
                              _vm.post.data.validHashtags
                                ? _vm.post.data.validHashtags
                                : undefined,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", { staticClass: "cta", class: _vm.post.status }, [
            _vm.post.status == "preview" &&
            _vm.sectionPlanner &&
            !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
              ? _c(
                  "div",
                  { staticClass: "change-news" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("dash.select.news.label"))),
                    ]),
                    _c(
                      "vs-select",
                      {
                        staticClass: "select-news",
                        attrs: {
                          autocomplete: "",
                          placeholder: _vm.$t("dash.select.news"),
                        },
                        model: {
                          value: _vm.changeNews,
                          callback: function ($$v) {
                            _vm.changeNews = $$v
                          },
                          expression: "changeNews",
                        },
                      },
                      _vm._l(
                        _vm.gridData.posts.filter(
                          (p) =>
                            !p.page[0] ||
                            (p.page[0] &&
                              p.page[0].status != 1 &&
                              p.page[0].status != 2)
                        ),
                        function (news, index) {
                          return _c("vs-select-item", {
                            key: index,
                            attrs: { value: news._id, text: news.title },
                          })
                        }
                      ),
                      1
                    ),
                    _c(
                      "vs-button",
                      {
                        staticClass: "page-btn",
                        attrs: {
                          "vs-type": "filled",
                          color: "#2F1937",
                          disabled: !_vm.changeNews,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changePost(_vm.post)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("dash.button.change.post")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.post.status == "posted" && _vm.post.page[0] && _vm.post.stats
              ? _c("div", { staticClass: "stats" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.table.title.stats")) + " :"),
                  ]),
                  _vm.post.page[0] &&
                  _vm.post.stats &&
                  _vm.post.page[0].network == "facebook"
                    ? _c(
                        "ul",
                        {
                          attrs: {
                            data: _vm.post.stats.find(
                              (i) => i.name == "post_impressions"
                            ).values[0].value,
                          },
                        },
                        [
                          _c("li", [
                            _c("img", {
                              staticClass: "icon-white",
                              attrs: {
                                src: require("../../assets/img/rss/icon_vues.svg"),
                                alt: "vues",
                              },
                            }),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.post.stats.find(
                                    (i) => i.name == "post_impressions"
                                  ).values[0].value
                                )
                              ),
                            ]),
                          ]),
                          _c("li", [
                            _c("img", {
                              staticClass: "icon-white",
                              attrs: {
                                src: require("../../assets/img/rss/icon_likes.svg"),
                                alt: "likes",
                              },
                            }),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.post.stats.find(
                                    (i) => i.name == "post_reactions_like_total"
                                  ).values[0].value
                                )
                              ),
                            ]),
                          ]),
                          _c("li", [
                            _c("img", {
                              staticClass: "icon-white",
                              attrs: {
                                src: require("../../assets/img/rss/icon_clicks.svg"),
                                alt: "clicks",
                              },
                            }),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.post.stats.find(
                                    (i) => i.name == "post_clicks"
                                  ).values[0].value
                                )
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm.post.page[0] &&
                      _vm.post.stats &&
                      _vm.post.page[0].network == "twitter"
                    ? _c(
                        "ul",
                        { attrs: { data: _vm.post.stats.retweet_count } },
                        [
                          _c("li", [
                            _c("img", {
                              staticClass: "icon-white",
                              attrs: {
                                src: require("../../assets/img/rss/icon_retweet.svg"),
                                alt: "vues",
                              },
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.post.stats.retweet_count)),
                            ]),
                          ]),
                          _c("li", [
                            _c("img", {
                              staticClass: "icon-white",
                              attrs: {
                                src: require("../../assets/img/rss/icon_likes.svg"),
                                alt: "likes",
                              },
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.post.stats.favorite_count)),
                            ]),
                          ]),
                          _vm.post.page[0] &&
                          _vm.post.page[0].network == "twitter"
                            ? _c(
                                "vs-button",
                                {
                                  staticClass: "btn-large",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openTweet(_vm.post)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("dash.posts.view")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "other-actions" },
              [
                _vm.post.status != "slot" &&
                !(
                  _vm.post._bots[0].page.isGroup &&
                  _vm.post._bots[0].page.network == "facebook"
                ) &&
                _vm.checkRetweet
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("dash.planner.sidebar.other-actions"))
                      ),
                    ])
                  : _vm._e(),
                _vm.post.status == "slot" &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-add-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.addPost(
                              null,
                              null,
                              _vm.post.date,
                              _vm.post._bots
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.add.post")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "preview" &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          disabled: _vm.validatePostAction,
                          "data-qa": "post-sidebar-validate-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.validatePost(_vm.post)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.sectionPlanner
                                ? _vm.$t("dash.button.validate.post")
                                : _vm.$t("dash.button.post")
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "preview" &&
                !_vm.sectionPlanner &&
                !(
                  _vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole)
                ) &&
                _vm.isUserPremiumActive &&
                !(
                  _vm.post._bots[0].mode === "story" &&
                  _vm.post._bots[0].page.story_config &&
                  _vm.post._bots[0].page.story_config.created
                )
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-schedule-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.scheduledPost(_vm.post)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.schedule")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "failed" &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-edit-error",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.editPost(
                              _vm.post._bots[0].page.id,
                              _vm.post._id,
                              _vm.post.status,
                              null,
                              _vm.post._bots
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.post")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "posted" &&
                !(
                  _vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole)
                ) &&
                _vm.post.page[0].network == "instagram" &&
                !_vm.post.page[0].story &&
                !_vm.post.page[0].video &&
                _vm.post._bots[0].page.story_config &&
                _vm.post._bots[0].page.story_config.created
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-edit-error",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.shareToStory(
                              _vm.post._bots[0].page.id,
                              _vm.post._id,
                              _vm.post.page[0].post_number
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.share.story")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                !(
                  _vm.post._bots[0].page.network === "instagram" &&
                  _vm.post.status == "failed"
                ) &&
                !(
                  _vm.post._bots[0].page.network === "instagram" &&
                  _vm.post.status == "posted" &&
                  (_vm.post.page[0].story ||
                    _vm.post.page[0].storification ||
                    !_vm.post._bots[0].page.story_config ||
                    !_vm.post._bots[0].page.story_config.created ||
                    !/^\d{19}_\d{11}$/.test(_vm.post.page[0].post_number)) &&
                  !(
                    _vm.post._bots[0].page.story_config &&
                    _vm.post._bots[0].page.story_config.created
                  )
                ) &&
                !(
                  _vm.post._bots[0].page.isGroup &&
                  _vm.post._bots[0].page.network == "facebook"
                ) &&
                !(_vm.invite || _vm.getUserRole == "Viewer") &&
                ((_vm.getUserRole != "Writter" &&
                  ((_vm.post.status == "posted" &&
                    !_vm.post.page[0].is_retweet) ||
                    ["failed", "scheduled", "draft"].includes(
                      _vm.post.status
                    ) ||
                    (_vm.post.status == "direct" &&
                      _vm.post._bots[0].page.network != "instagram"))) ||
                  (_vm.getUserRole == "Writter" &&
                    _vm.post.status == "draft")) &&
                !(
                  [
                    "oneSignal",
                    "wonderpush",
                    "batch",
                    "tiktok",
                    "threads",
                    "whatsapp",
                    "bluesky",
                  ].includes(_vm.post._bots[0].page.network) &&
                  _vm.post.status == "posted"
                )
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx delete",
                        attrs: {
                          type: "filled",
                          disabled:
                            (_vm.disableAddPost || _vm.editDraftNotAllowed) &&
                            _vm.post.status == "posted",
                          "data-qa": "post-sidebar-delete-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.deletePost(_vm.post)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.delete.post")) +
                            "\n        "
                        ),
                        _c("img", {
                          attrs: {
                            src: require("./../../assets/img/Trash-icon.svg"),
                            alt: "trash",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                (_vm.post.status == "preview" || _vm.post.status == "slot") &&
                _vm.sectionPlanner &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-delete-slot",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.deleteSlot(
                              _vm.post.preview_date || _vm.post.date,
                              _vm.post._bots[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.delete.slot")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "preview" &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-exclude-news",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.excludeNews(_vm.post)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.exclude.news")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.post.status == "posted" &&
                !(
                  _vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole)
                ) &&
                !_vm.post.page[0].is_reshare &&
                !_vm.post.page[0].is_retweet &&
                (_vm.post._bots[0].page.network == "facebook" ||
                  _vm.post._bots[0].page.network == "twitter" ||
                  _vm.post._bots[0].page.network == "linkedin")
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-reshare-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resharePost(
                              _vm.post._bots[0].page.id,
                              _vm.post._id,
                              _vm.post.page[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.reshare")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.checkRetweet &&
                !(_vm.invite || ["Writter", "Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-retweet-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.retweetPost(
                              _vm.post._bots[0].page.id,
                              _vm.post._id,
                              _vm.post.page[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.retweet")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                !(_vm.invite || ["Viewer"].includes(_vm.getUserRole))
                  ? _c(
                      "vs-button",
                      {
                        staticClass: "btnx",
                        attrs: {
                          type: "filled",
                          "data-qa": "post-sidebar-duplicate-post",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.duplicatePost(_vm.post)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.button.duplicate")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                ["scheduled", "posted", "failed", "draft"].includes(
                  _vm.post.status
                )
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "deeplink-post",
                          on: {
                            click: function ($event) {
                              return _vm.copyDeepLinkPost()
                            },
                          },
                        },
                        [
                          _vm.deepLinkPost
                            ? _c("span", { staticClass: "link" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("link"),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("dash.post.copy.deeplink.post")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "comments-title" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("dash.post.title.notes")) +
                            "\n        "
                        ),
                      ]),
                      _vm.post.page[0] &&
                      _vm.post.page[0].comments &&
                      _vm.post.page[0].comments.length
                        ? _c(
                            "ul",
                            { staticClass: "comments" },
                            _vm._l(
                              _vm.post.page[0].comments,
                              function (comment, index) {
                                return _c("li", { key: index }, [
                                  _vm.post.status != "draft" ||
                                  (_vm.post.status == "draft" &&
                                    (!comment.bot ||
                                      comment.bot == _vm.post._bots[0].id))
                                    ? _c("div", [
                                        _c("p", { staticClass: "name" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(comment.name) +
                                              "\n                "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "date" },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.dateFormat(
                                                      comment.date
                                                    ),
                                                    position: "top",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateFromNow(
                                                          comment.date
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    "\n                     \n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _c("p", { staticClass: "message" }, [
                                          _vm._v(_vm._s(comment.message)),
                                        ]),
                                        _c(
                                          "ul",
                                          { staticClass: "medias" },
                                          _vm._l(
                                            comment.mediasUpload,
                                            function (media, index) {
                                              return _c("li", { key: index }, [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      target: "_blank",
                                                      href: media.url,
                                                    },
                                                  },
                                                  [
                                                    media.type.includes("image")
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: media.url,
                                                          },
                                                        })
                                                      : media.type.includes(
                                                          "video"
                                                        )
                                                      ? _c("video", {
                                                          attrs: {
                                                            src: media.url,
                                                          },
                                                        })
                                                      : media.type.includes(
                                                          "application/x-zip-compressed"
                                                        )
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("../../assets/img/zip_reference_icon.svg"),
                                                          },
                                                        })
                                                      : media.type.includes(
                                                          "application/pdf"
                                                        )
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: require("../../assets/img/pdf_reference_icon.svg"),
                                                          },
                                                        })
                                                      : _c("img", {
                                                          attrs: {
                                                            src: require("../../assets/img/document_app_essential_icon.svg"),
                                                          },
                                                        }),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          media.url
                                                            .split("/")
                                                            .pop()
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "add-comment" },
                        [
                          _c("vs-textarea", {
                            staticClass: "inputx message",
                            attrs: {
                              "vs-size": "large",
                              color: "#B20564",
                              name: "message",
                              placeholder: _vm.$t("dash.post.add.comment"),
                            },
                            model: {
                              value: _vm.message,
                              callback: function ($$v) {
                                _vm.message = $$v
                              },
                              expression: "message",
                            },
                          }),
                          _c(
                            "label",
                            { staticClass: "uploadFile" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.post.limit_media_note"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/icon_paperclip.svg"),
                                    },
                                  }),
                                  _c("input", {
                                    staticClass: "inputfile form-control",
                                    attrs: {
                                      type: "file",
                                      id: "attachment",
                                      name: "attachment",
                                      multiple: "true",
                                    },
                                    on: { change: _vm.previewFiles },
                                  }),
                                  _vm._v("\n               \n            "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.percentUpload
                            ? _c(
                                "vs-progress",
                                {
                                  attrs: {
                                    percent: _vm.percentUpload,
                                    color: "primary",
                                  },
                                },
                                [_vm._v("primary")]
                              )
                            : _vm._e(),
                          _vm.percentUpload
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.percentUpload) + " %"),
                              ])
                            : _vm._e(),
                          _c(
                            "ul",
                            { staticClass: "medias" },
                            _vm._l(_vm.mediasUpload, function (media, index) {
                              return _c("li", { key: index }, [
                                media.type.includes("image")
                                  ? _c("img", { attrs: { src: media.url } })
                                  : media.type.includes("video")
                                  ? _c("video", { attrs: { src: media.url } })
                                  : media.type.includes(
                                      "application/x-zip-compressed"
                                    )
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/zip_reference_icon.svg"),
                                      },
                                    })
                                  : media.type.includes("application/pdf")
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/pdf_reference_icon.svg"),
                                      },
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/document_app_essential_icon.svg"),
                                      },
                                    }),
                                _c("span", [
                                  _vm._v(_vm._s(media.url.split("/").pop())),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFile(media)
                                      },
                                    },
                                  },
                                  [_vm._v("remove")]
                                ),
                              ])
                            }),
                            0
                          ),
                          _c(
                            "vs-button",
                            {
                              staticClass: "btnx",
                              attrs: { type: "filled" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.addComment()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("dash.button.create")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "vs-prompt",
            {
              staticClass: "prompt-remove-posts",
              attrs: {
                color: "#6a1f4c",
                "cancel-text": _vm.$t(
                  "dash.posts.multi-pages.remove.prompt.btn-only-one"
                ),
                "accept-text": _vm.$t(
                  "dash.posts.multi-pages.remove.prompt.btn-all"
                ),
                title: _vm.$t("dash.posts.multi-pages.remove.prompt.title"),
                active: _vm.removePostsMultiPages,
              },
              on: {
                close: function ($event) {
                  _vm.removePostsMultiPages = false
                },
                cancel: function ($event) {
                  _vm.post.status == "draft"
                    ? _vm.removeDraft(_vm.post._bots[0].page)
                    : _vm.removePost()
                },
                accept: function ($event) {
                  _vm.post.status == "draft"
                    ? _vm.removeDraft()
                    : _vm.deletePostsMultiPages()
                },
                "update:active": function ($event) {
                  _vm.removePostsMultiPages = $event
                },
              },
            },
            [
              _c("div", { staticClass: "con-exemple-prompt" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("dash.posts.multi-pages.remove.prompt.content")
                    ) +
                    "          \n      "
                ),
              ]),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }